import React from 'react';
import Header from './components/header';
import Footer from './components/footer';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <>
            <Header></Header >
            <div className='not_found'>
                <div className='not_found_404'>404</div>
                <div className='not_found_content'>
                    <h2>Page not found</h2>
                    <p>The page you're looking for does not exist.</p>
                    <div className='text-center'>
                        <Link to='/'>
                        <button className="load_more_btn">
                            Back To Homepage
                        </button>
                        </Link>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </>
    );
};

export default NotFound;